import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const getQuotation = async (id: any) => {
  const response = await fetch(`${REACT_APP_VMS_BASE_URL}/quotations/${id}`);
  const result = await response.json();
  return result;
};

export default getQuotation;
